import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import CommentsIcon from '@/assets/icons/comments.svg';
import CommentsOutlineIcon from '@/assets/icons/comments_outline.svg';

interface CommentButtonProps {
  commentCount: number;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  filled?: boolean;
}

export function CommentButton({ 
  commentCount, 
  onClick, 
  className,
  disabled = false,
  filled = false
}: CommentButtonProps) {
  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "group h-8 w-8 p-0 hover:bg-red-50/10",
          filled ? "text-sossiety-red-600 hover:text-sossiety-red-500" : "text-gray-200 hover:text-sossiety-red-600",
          "focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 active:outline-none active:ring-0",
          "transition-none",
          className
        )}
      >
        {filled ? (
          <img src={CommentsIcon} width={20} height={20} alt="Comments" />
        ) : (
          <img src={CommentsOutlineIcon} width={20} height={20} alt="Comments outline" />
        )}
      </Button>
      <span className="!ml-0 font-medium text-gray-200">
        {commentCount}
      </span>
    </div>
  );
} 